import React, { useState, useEffect } from "react";
import axios from "axios"; // Import Axios
import { marked } from 'marked'; // Import the marked library
import { Card, CardContent, Typography, createTheme, ThemeProvider } from '@mui/material'; // Import Material-UI components
import '../homeStyles.css'; // Import CSS file
import Footer from './Footer'; // Import Footer component
import NowPlaying from "../components/NowPlaying";

const Personal = () => {
  const [portfolioCard, setPortfolioCard] = useState(null); // State to hold the blog posts

  // Create a custom theme with Roboto font for all typography
  const theme = createTheme({
    typography: {
      fontFamily: 'Roboto, sans-serif', // Set Roboto as the font family
    },
  });

  useEffect(() => {
    // Fetch the blog posts from Strapi
    const fetchPortfolioCards = async () => {
      try {
      const response = await axios.get('https://strapi-app-665134228599.us-central1.run.app/api/portfolio-cards/2?populate=*', {
        headers: {
          'Authorization': "Bearer 9fbc07b4949b91d5064e6bad40161ef91712b5e9afad699b0fa6acfe62d2dd72baac03de86965e68f77eb8d04f70ca38f3feca973a8fc62c7bd332b59c2bbd0fdbdfcb7e933ea18797bdfc484574fd32a54a2763c6f22faba3bb580c9ffc8862d7f26c2737186665bf50a9d2d1c10434cde408927cff6f0ee7dc141335129dae", // Replace with your API token
        },
      });
      setPortfolioCard(response.data.data); // Assuming the response structure
      } catch (error) {
        console.error("Error fetching portfolio cards:", error);
      }
    };

    fetchPortfolioCards();
  }, []);

  // Construct the full image URL
  const getImageUrl = (image) => {
    const baseUrl = 'https://strapi-app-665134228599.us-central1.run.app'; // Your Strapi base URL
    return image ? `${baseUrl}${image}` : '';
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="container"> {/* Apply container class */}
      {portfolioCard ? (
        <Card className="card" sx={{backgroundColor: 'rgba(255, 255, 255, 0.95)'}}>
          <CardContent className="card-content">
            <Typography variant="h4" component="h2">
            {portfolioCard.attributes.Title}
            </Typography>
            <br />
            <Typography variant="body2" component="p">
            {new Date(portfolioCard.attributes.Date).toLocaleDateString()}
            </Typography>
             {/* Display the image */}
             {/*{portfolioCard.attributes.Images.data.length > 0 && (
                <img
                  src={getImageUrl(portfolioCard.attributes.Images.data[0].attributes.url)}
                  alt={portfolioCard.attributes.Images.data[0].attributes.alternativeText || 'Image'}
                  style={{ maxWidth: '8%', height: 'auto' }}
                />
              )} */}
            <br />
            <Typography variant="body1" component="div" dangerouslySetInnerHTML={{ __html: marked(portfolioCard.attributes.RichText) }} /> {/* Change variant to body1 */}
          </CardContent>
        </Card>
      ) : (
        <Typography variant="h6" component="p">
            Loading...
          </Typography>
      )}
        <Footer /> {/* Add Footer component */}
      </div>
      <NowPlaying/>
    </ThemeProvider>
  );
}

export default Personal;
